import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { get_jwt_token, isTokenExpired } from '../../../api/helper_funtions';
import { loadUser } from '../../../state/slices/user';
import { useAppTheme } from '../../../theme/useTheme';
import { challenge_from_verifier, generateRandomString, getSHA512Hash, text2Binary } from '../../../utils/oAuthHelperFuntion';
import Loader from '../../common/Loader/Loader';
import './login.css';

function Login(props) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { isAuthenticated } = useSelector((state) => state.user);
  const { serverUrl } = useSelector((state) => state.customer);
  const { mode } = useAppTheme();

  const fetchData = async () => {

    const token = get_jwt_token();
    if (!token || isTokenExpired(token) || isAuthenticated === false) {
      initiateOauthFlowPKCE();
    } else {
      dispatch(loadUser());
    }


  };
  useEffect(() => {
    fetchData();
  }, [isAuthenticated, navigate, dispatch]);

  const initiateOauthFlowPKCE = async () => {
    const code_verifier = generateRandomString(7);
    const code_challenge = await challenge_from_verifier(code_verifier);
    const code_challenge_method = 'S256';
    const redirect_uri = window.location.origin + '/pam/token'
    const client_id = "AvvDWAJywgGPQsn3qgSXlsEe9yYWkz61"; 
    const normalizeLanguage = (value) => {
      if (!value || typeof value !== "string") return null;
      const supported = [
        'en', 'es', 'fr', 'de', 'ar',
        'it', 'pt', 'ru', 'zh-CN', 'zh-TW',
        'ja', 'ko', 'hi', 'bn', 'ur',
        'tr', 'nl', 'pl', 'sv', 'da',
        'fi', 'no', 'el', 'cs', 'id', 'mr',
      ];
      const v = value.trim();
      if (supported.includes(v)) return v;
      const lower = v.toLowerCase();
      const exact = supported.find(l => l.toLowerCase() === lower);
      if (exact) return exact;
      const base = lower.split(/[-_]/)[0];
      return supported.find(l => l.toLowerCase() === base) || null;
    };
    const languagePreference =
      normalizeLanguage(localStorage.getItem("i18nextLng")) || "en";
    let state = {
      "V": text2Binary(code_verifier),
      "H": await getSHA512Hash(code_verifier)
    }
    state = btoa(JSON.stringify(state));
    const server_url = `${serverUrl}/autheticate/authorize/`; 
    const url = `${server_url}?client_id=${client_id}&redirect_uri=${redirect_uri}&scope=openid%20profile%20email&state=${state}&code_challenge=${code_challenge}&code_challenge_method=${code_challenge_method}&language=${encodeURIComponent(languagePreference)}`
    window.location.href = url;
  }
  return (
    <div className="login-page-container" data-theme={mode}>
      <Loader loading={true} bg_papper={false} />
    </div>
  )
}
export default Login;